var global = global || window;
(window).process = {
    env: { DEBUG: undefined },
    version: ''
};

global.Buffer = global.Buffer || require('buffer').Buffer;
